import axios, { AxiosRequestConfig } from 'axios';
import FileDownload from 'js-file-download';

import { headers } from 'store/service/requestManagement';
import CONFIG, { versionUrl, } from '@root/config/config.next';

export const handleExportFile = (params, fileName, method) => {

  console.log("[export] export file ::", params, fileName);
  const url = `${CONFIG.backendEndpoint}/backend/v1/order/history-export`;

  const request = axios({
    url: url,
    method: method || "GET",
    headers: headers,
    params: params,
    dataType: 'json',
    responseType: 'blob',
  });
  return request
    .then((res) => {
      FileDownload(res.data, fileName);
    })
    .catch((err) => {
      console.log('file export error', err);
    });
};

export const handleExportXLSXFile = ({ file_url, file_name, params }) => {

  console.log("[export] export file ::", file_name, params);

  const request = axios({
    url: file_url,
    method: "GET",
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Accept': 'application/octet-stream',
    },
    params: params,
    dataType: 'json',
    responseType: 'blob',
  });
  return request
    .then((res) => {
      FileDownload(res.data, file_name);
    })
    .catch((err) => {
      console.log('file export error', { err });
    });
};

